import { IconButton } from "@mui/material";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CreateOutsourceOrderTitleBar } from "../../../configs/outsourceOrder";
import { Provider } from "../../../data/entities";
import { BackButtonRow } from "../../../shared/components/BackButton/Styled";
import { api } from "../../../shared/hooks/api";
import { BackButtonStyle, TitleText, TitleWrapper } from "../../../shared/styled/TitleBar";
import BackIcon from "../../../shared/svg/BackIcon";
import { error, success } from "../../../utils/toast";
import SelectProviders from "../../MaterialOrder/create/SelectProviders";
import { OutsourceOrderWrapper } from "../Styled";

const OutsourceUnitTableColumns = [
    { text: "Mã đơn vị gia công", icon: <></> },
    { text: "Tên đơn vị gia công", icon: <></> },
    { text: "Số điện thoại", icon: <></>, width: "150px" },
    { text: "Email", icon: <></>, width: "280px" },
    { text: "Người liên hệ", icon: <></> },
];

const OUTSOURCE_ORDER_TAB_URL = "/material-orders?tab=outsource%20orders";
const OUTSOURCE_ORDER_RETURN_QUERY = "returnTab=outsource%20orders";

export const CreateOutsourceOrder = () => {
    const [{ isCreating }, createOutsourceOrder] = api.post("/materials/outsource-orders/");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const submittingRef = useRef(false);
    const navigate = useNavigate();

    const onSelectProvider = async (selectedProvider: Provider) => {
        if (submittingRef.current) return;
        submittingRef.current = true;
        setIsSubmitting(true);

        try {
            const order = await createOutsourceOrder({
                provider: selectedProvider,
                provider_id: selectedProvider.id,
                provider_name: selectedProvider.name,
                due_date: new Date().toISOString().split("T")[0],
                is_urgent: false,
                source_first: true,
                materials: [],
                first_storage_keeper: [],
                second_storage_keeper: [],
                total_price: 0,
            }) as { id: string };
            success("THÀNH CÔNG", "Tạo đơn hàng gia công thành công");
            navigate(`/outsource-orders/${order.id}?${OUTSOURCE_ORDER_RETURN_QUERY}`);
        } catch (err) {
            error("Lỗi tạo đơn hàng gia công", err);
        } finally {
            submittingRef.current = false;
            setIsSubmitting(false);
        }
    };

    return (
        <OutsourceOrderWrapper>
            <BackButtonRow>
                <IconButton style={BackButtonStyle} onClick={() => navigate(OUTSOURCE_ORDER_TAB_URL)} disabled={isSubmitting || isCreating}>
                    <BackIcon />
                </IconButton>
                Trở về
            </BackButtonRow>

            <TitleWrapper>
                <TitleText>{CreateOutsourceOrderTitleBar.title}</TitleText>
            </TitleWrapper>

            {(isSubmitting || isCreating) && <div role="status">Đang tạo đơn hàng gia công...</div>}

            <div style={{ pointerEvents: isSubmitting || isCreating ? "none" : "auto", opacity: isSubmitting || isCreating ? 0.6 : 1 }}>
                <SelectProviders
                    setSelectedProvider={onSelectProvider}
                    confirmSelection
                    onCancelSelection={() => navigate(OUTSOURCE_ORDER_TAB_URL)}
                    isSubmitting={isSubmitting || isCreating}
                    title="Vui lòng lựa chọn đơn vị gia công"
                    searchText="Tìm kiếm theo từ khoá Mã đơn vị gia công, Tên đơn vị gia công"
                    tableColumns={OutsourceUnitTableColumns}
                    queryParams={{ is_outsource_provider: true }}
                />
            </div>
        </OutsourceOrderWrapper>
    );
};
